import { PayloadAction } from '@reduxjs/toolkit';
import { DTOWorkspaceSubscription } from '@shared/dto/+workspace/workspace_subscription/dto_workspace_subscription';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { StateWorkspaceBilling } from './state_workspace_billing';

export const local_billing_workspace_subscriptions_upsert = (payload: DTOWorkspaceSubscription[]): PayloadAction<DTOWorkspaceSubscription[]> => ({
  type: ENUM__redux_action.WORKSPACE_BILLING_SUBSCRIPTIONS_UPSERT,
  payload: payload,
});

export const init_local_billing_workspace_subscriptions_upsert = (state: StateWorkspaceBilling, action: PayloadAction<DTOWorkspaceSubscription[]>) => {
  if (action.payload.is_empty()) return;

  for (let item of action.payload) {
    state.subscriptions_map.set(item._id, item);
  }

  //need to force a re-render
  state.subscriptions_map = new Map(state.subscriptions_map);
};
